/**
 * Write-only sentinel asking the database to atomically add `amount` to the
 * field's current numeric value — the Firebase-free stand-in for Firestore's
 * `increment()`. On a missing or non-numeric field the database sets the field
 * to `amount`. Use it inline in a write; it is never read back, since reads
 * always yield a concrete `number`.
 */
export class JcIncrement {
    constructor(readonly amount: number) { }
}
